import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openHoverSidebar, closeHoverSidebar } from '../../Redux/Slices/layoutSlice';
import SidebarItem from './sidebarItem';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import CampaignIcon from '@mui/icons-material/Campaign';
import { HiOutlineAdjustments } from 'react-icons/hi';
import { MdOutlineInventory2 } from "react-icons/md";
import { hasPermission } from '../../utils/permissions';
import { TfiTimer } from "react-icons/tfi";
import { MdOutlineWorkHistory } from "react-icons/md";
import { MdPersonOutline } from "react-icons/md";
import { TbTax } from "react-icons/tb";
import { MdOutlinePayments } from "react-icons/md";
import CustomPopupForm from '../../component/customPopupModel';
import { BsBroadcastPin,BsBugFill } from "react-icons/bs";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdOutlineLocalShipping } from "react-icons/md";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';


const adminMenuItems = [
  { icon: DashboardCustomizeOutlinedIcon, label: 'Dashboard', path: '/app/analytics-dashboard' },
  { icon: PersonOutlineOutlinedIcon, label: 'User Management', path: '/app/user-management' },
  { icon: HiOutlineUserGroup, label: 'Customers', path: '/app/customers', permissionResource: 'User Management' },
  { icon: MdOutlineLocalShipping, label: 'Order Tracking', path: '/app/order-tracking', permissionResource: 'User Management' },
  { icon: VerifiedUserOutlinedIcon, label: 'Approval Dashboard', path: '/app/approval-dashboard' },
  { icon: ManageAccountsOutlinedIcon, label: 'RBAC Management', path: '/app/rbac-management' },
  {
    icon: SettingsOutlinedIcon,
    label: 'Settings',
    children: [
      { label: 'Service Settings', path: '/app/service-setting' },
      { label: 'Configuration Settings', path: '/app/configuration-settings' },
    ],
  },
  { icon: MdOutlinePayments, label: 'Payment And Payout', path: '/app/payment&payout' },
  { icon: BsBroadcastPin, label: 'Broadcast', path: '/app/broadcast' },
  { icon: BsBugFill, label: 'Incident Reports', path: '/app/delivery-incedents', permissionResource: 'Incedent Reports' },
  { icon: LogoutIcon, label: 'Logout', path: '/app/logout' },
];

const deliveryMenuItems = [
  { icon: DashboardCustomizeOutlinedIcon, label: 'Earnings Dashboard', path: '/delivery/earnings-dashboard' },
  { icon: TfiTimer, label: 'Weekly Schedule', path: '/delivery/availability-calendar'},
  { icon: MdOutlineWorkHistory, label: 'Task History', path: '/delivery/task-history' },
  { icon: MdPersonOutline, label: 'My Profile', path: '/delivery/profile' },
  { icon: TbTax, label: 'Tax Summary', path: '/delivery/tax-summary' },
  { icon: LogoutIcon, label: 'Logout', path: '/app/logout' },
];

const businessMenuItems = [
  { icon: DashboardCustomizeOutlinedIcon, label: 'Analytics and report', path: '/app/dashboard' },
  { icon: ManageAccountsOutlinedIcon, label: 'RBAC Management', path: '/app/business/rbac-management' },
  {
    icon: HiOutlineAdjustments,
    label: 'Operational Setting',
    children: [
      { label: 'Store Operations', path: '/app/operational-setting' },
      { label: 'Service Configuration', path: '/app/service-configuration' },
      { label: 'Service Area', path: '/app/service-area' },
      { label: 'Customer Management', path: '/app/customer-management' },
      { label: 'Order Management', path: '/app/order-management' },
      { label: 'Pricing Tiers', path: '/app/pricing-tiers' },
    ],
  },
  { icon: FeedbackOutlinedIcon, label: 'Feedback Management', path: '/app/feedback' },
  { icon: CampaignIcon, label: 'Promotions & Marketing', path: '/app/promotions&marketing' },
  // { icon: CampaignIcon, label: 'Promotions & Marketing', path: '/app/development' },
  { icon: MdOutlineInventory2, label: 'Inventory Management', path: '/app/inventory' },
  { icon: LogoutIcon, label: 'Logout', path: '/app/logout' },

];

const Sidebar = () => {
   const { isStripeAccount } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const { isSidebarOpen, isSidebarHovered } = useSelector((state) => state.layout);
  const { loginDetails } = useSelector((state) => state.counter);
  const sidebarExpanded = isSidebarOpen || isSidebarHovered;
  const permissions = useSelector(state => state.counter.permissions);
  const rolePermissions = permissions?.[0]?.permissions || [];



  const getMenuItems = () => {
    if (loginDetails?.userType === 'admin') return adminMenuItems;
    if (loginDetails?.userType === 'business user' || loginDetails?.userType === 'employee user') return businessMenuItems;
    return deliveryMenuItems;
  };


  const filteredMenuItems = getMenuItems()
    .map((item) => {
      if (!item.children) return item;
      if (!permissions || permissions.length === 0) return item;
      const visibleChildren = item.children.filter((child) =>
        hasPermission(
          rolePermissions,
          child.permissionResource || child.label,
          "view"
        )
      );
      return { ...item, children: visibleChildren };
    })
    .filter((item) => {
      if (!permissions || permissions.length === 0) return true;
      if (item.label === "Logout") return true;

      if (item.children) {
        return item.children.length > 0;
      }
      const resource = item.permissionResource || item.label;
      return hasPermission(rolePermissions, resource, "view");
    });

  useEffect(() => {
    if (!sidebarExpanded) {
      setExpandedItem(null);
    }
  }, [sidebarExpanded]);

  const handleItemClick = (label, path) => {
    if (label === 'Logout') { 
      setOpen(true)
    } else if (path) {
      navigate(path);
    }
  };

  const handleExpandItem = (label) => {
    setExpandedItem(label);
  };

  const handleToggleItem = (label) => {
    setExpandedItem((prev) => (prev === label ? null : label));
  };

  const handleCollapseItem = (label, hasActiveChild) => {
    if (hasActiveChild) return;
    setExpandedItem((prev) => (prev === label ? null : prev));
  };

  return (
    <div>
      <aside
        onMouseEnter={() => dispatch(openHoverSidebar())}
        onMouseLeave={() => dispatch(closeHoverSidebar())}
        className={`fixed top-16 left-0 z-40 h-[calc(100vh-64px)] bg-[var(--primary-bg-color)] pb-6 shadow-xl overflow-y-auto overflow-x-hidden scrollbar-hide
      transition-all duration-700 ease-in-out transform px-2
      ${sidebarExpanded ? 'w-74' : 'w-[70px] hidden  md:block'}
      rounded-tr-2xl rounded-br-2xl`}
      >
        <ul className="mt-8">
          {filteredMenuItems.map(({ icon, label, path, children }, i) => {
            const hasActiveChild =
              children?.some((child) =>
                location.pathname.includes(child.path)
              ) || false;

            return (
            <SidebarItem
              key={i}
              label={label}
              Icon={icon}
              path={path}
              children={children}
              sidebarExpanded={sidebarExpanded}
              isSelected={
                location.pathname.includes(path) ||
                hasActiveChild
              }
              activeSubPath={location.pathname}
              expanded={expandedItem === label || hasActiveChild}
              onExpand={() => handleExpandItem(label)}
              onToggle={() => handleToggleItem(label)}
              onCollapse={() => handleCollapseItem(label, hasActiveChild)}
              onClick={(p) => handleItemClick(label, p || path)}
            />
            );
          })}
        </ul>
      </aside>
      <CustomPopupForm
        isOpen={open}
        handleClose={() => setOpen(false)}
        dialogType="logout"
      />
    </div>
  );
};

export default Sidebar;